/**
 * Marca Panda Video (asset local — evita dependência de URL externa do dashboard).
 */
export const PANDA_OFFICIAL_LOGO_SVG = '/icons/pandav.svg';
